export const isActiveLink = (currentUrl, routesUrl, contains) => {
  // The favourite page is the home page, so show that link as active if the currentUrl is blank.
  const linkUrl = currentUrl === '/' ? '/favourites' : currentUrl;
  return contains ? linkUrl.includes(routesUrl) : linkUrl === routesUrl;
};

export { isActiveLink as default };
